"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vue = _interopRequireDefault(require("vue"));

var _isPC = _interopRequireDefault(require("./isPC"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue.default.directive('show-in-pc', {
  inserted: function inserted(el, binding) {
    if (binding.value !== (0, _isPC.default)()) {
      el.remove();
    }
  }
});

function regist(Vue) {
  if (regist.installed) {
    return;
  }

  var isPc = (0, _isPC.default)();
  Vue.component('j-pc', Vue.extend({
    template: '<div @click="handleClick" v-if="isPC"><slot /></div>',
    data: function data() {
      return {
        isPC: isPc
      };
    },
    methods: {
      handleClick: function handleClick(e) {
        this.$emit('click', e);
      }
    }
  }));
  Vue.component('j-mobile', Vue.extend({
    template: '<div @click="handleClick" v-if="!isPC"><slot /></div>',
    data: function data() {
      return {
        isPC: isPc
      };
    },
    methods: {
      handleClick: function handleClick(e) {
        this.$emit('click', e);
      }
    }
  })); // eslint-disable-next-line no-param-reassign

  Vue.prototype.$isPc = isPc;
}

var _default = regist;
exports.default = _default;